import styled from "@emotion/styled";
import theme from "@theme";
import { css, Global } from "@emotion/react";

const MainComponent = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.width || "100%"};
  border: ${(props) => props.border || `2px solid ${theme.colors.border}`};
  border-radius: 5px;
  margin-right: ${(props) => props.marginRight || "100px"};
  margin-bottom: 10px;
  margin-left: 0px
  box-shadow: ${(props) =>
    props.boxShadow ||
    "0px 2px 1px -1px rgba(0, 0, 0, 0.2),0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)"};
`;

const Heading = styled.div`
  color: ${theme.colors.themeColor};
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 5px;
`;

const globalStyles = css`
  .css-15v22id-MuiAccordionDetails-root {
    padding: 0px 16px 16px !important;
  }

  .css-1f773le-MuiButtonBase-root-MuiAccordionSummary-root {
    height: 0px !important;
  }
  .css-1086bdv-MuiPaper-root-MuiAccordion-root {
    box-shadow: none !important;
  }
`;

const SC = {
  MainComponent,
  Heading,
  Globalstyles: <Global styles={globalStyles} />,
};

export default SC;
